<template>
	<component :is="badge.element ? badge.element : 'span'" class="vsm--badge" :class="badge.class"
		v-bind="badge.attributes">
		{{ localText }}
	</component>
</template>

<script>
export default {
	name: 'SidebarMenuBadge',
	props: {
		badge: {
			type: Object,
			default: () => ({ id: '', type: '', text: '', attributes: {}, class: '' })
		}
	},
	data() {
		return {
			localText: this.badge?.text ?? 0
		};
	},
	mounted() {
		this.$bus.$on('worker:sage:export', this.loadInitial);
    	this.loadInitial();
	},
	beforeDestroy() {
    	this.$bus.$off('worker:sage:export', this.loadInitial);
  	},
	methods: {
		onBadgeUpdate(payload) {
			if (this.badge.type === payload.type) {
				this.localText = payload.value;
			}
		},
		loadInitial() {
			// if (this.badge.type === 'sage_export_genius_payroll_pl' || this.badge.type === 'sage_export_genius_contracts_pl') {
			// 	axios.get(this.crmApiPath + 'finance/export/worker/payroll/count?type=' + this.badge.type).then(res => {
			// 		this.localText = res.data.data;
			// 	});
      //
			// 	return;
			// }
      //
			// if (this.badge.type === 'sage_export_genius_payroll_acc' || this.badge.type === 'sage_export_genius_contracts_acc') {
			// 	axios.get(this.crmApiPath + 'finance/export/worker/accounts/count?type=' + this.badge.type).then(res => {
			// 		this.localText = res.data.data;
			// 	});
      //
			// 	return;
			// }
      //
			// if (this.badge.type === 'sage_export_v3_paye_pl' || this.badge.type === 'sage_export_v3_contract_pl') {
			// 	axios.get(this.crmApiPath + 'finance/export/worker/payroll/count?type=' + this.badge.type).then(res => {
			// 		this.localText = res.data.data;
			// 	});
      //
			// 	return;
			// }
      //
			// if (this.badge.type === 'sage_export_v3_paye_acc' || this.badge.type === 'sage_export_v3_contract_acc') {
			// 	axios.get(this.crmApiPath + 'finance/export/worker/accounts/count?type=' + this.badge.type).then(res => {
			// 		this.localText = res.data.data;
			// 	});
      //
			// 	return;
			// }
      //
			// if(this.badge.type === 'tax_export') {
      //
			// 	axios.get(this.crmApiPath + 'finance/export/worker/tax/list_export').then(res => {
			// 		this.localText = res.data.length;
			// 	});
      //
			// 	return;
			// }
		}
	}
}
</script>
